import axios from 'axios';
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import { canAccessModule, getEffectivePermissions, getPermissionRegistry as getSharedPermissionRegistry, hasPermission as permissionHas } from '../utils/permissions';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function signUp(email, password) {
    // Registration is now via super admin - no public signup
    return Promise.reject({ response: { data: { error: 'Registration is disabled. Contact your administrator to create an account.' } } });
}

export function login(identifier, password) {
    // identifier = email OR username
    return axios.post(`${API_BASE}/auth/login`, {
        identifier,
        password,
    });
}

export function formatError(errorResponse) {
    if (!errorResponse) return 'Something went wrong';
    if (!errorResponse.response) {
        if (errorResponse.code === 'ERR_NETWORK' || errorResponse.message?.includes('Network')) {
            return 'Cannot connect to server. Make sure the backend is running on http://localhost:5000';
        }
        return errorResponse.message || 'Something went wrong';
    }
    const data = errorResponse.response.data;
    const msg = typeof data === 'object' && data.error ? data.error : data;
    if (typeof msg === 'string') return msg;
    if (typeof msg === 'object' && msg?.message) return msg.message;
    return 'Invalid credentials';
}


export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}

export function isLogin() {
    const tokenDetailsString = localStorage.getItem('userDetails');

    if (tokenDetailsString) {
        return true;
    }else{
        return false;
    }
}

export function getAuthToken() {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) return null;
    const tokenDetails = JSON.parse(tokenDetailsString);
    return tokenDetails.idToken;
}

export function isSuperAdmin() {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) return false;
    const tokenDetails = JSON.parse(tokenDetailsString);
    return tokenDetails.role === 'super_admin';
}

export function isAdmin() {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) return false;
    const tokenDetails = JSON.parse(tokenDetailsString);
    return tokenDetails.role === 'super_admin' || tokenDetails.role === 'admin';
}

export function getSavedUser() {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) return null;
    return JSON.parse(tokenDetailsString);
}

export function getCurrentUserId() {
    const user = getSavedUser();
    return user?.localId ? parseInt(user.localId, 10) : null;
}

export function getPermissionRegistry() {
    return getSavedUser()?.permission_registry || getSharedPermissionRegistry();
}

export function getEffectivePermissionKeys() {
    return Array.from(getEffectivePermissions(getSavedUser()));
}

export function hasPermission(permissionKey) {
    return permissionHas(getSavedUser(), permissionKey);
}

export function canViewModule(moduleKey) {
    return canAccessModule(getSavedUser(), moduleKey);
}
